/* User-requested, first-party functional favorites. No tracking or account data. */
(function () {
  'use strict';
  if (window.DiggitFavorites) return;
  const KEY = 'diggit:favorites:v1';
  let items = [], persistent = true;
  const normalize = value => {
    if (!Array.isArray(value)) return [];
    const seen = new Set();
    return value.filter(x => x && /^\d+$/.test(String(x.id)) && typeof x.handle === 'string' && x.handle.length > 0 && x.handle.length <= 255 && !/[\s/?#\\]/.test(x.handle)).map(x => ({id:String(x.id),handle:x.handle})).filter(x => {if (seen.has(x.id)) return false; seen.add(x.id); return true;});
  };
  function read() {
    try { items = normalize(JSON.parse(localStorage.getItem(KEY) || '[]')); }
    catch (error) { if (!(error instanceof SyntaxError)) persistent = false; }
  }
  read();
  function getAll() { return items.map(x => ({...x})); }
  function has(id) { return items.some(x => x.id === String(id)); }
  function refresh(root) {
    (root || document).querySelectorAll('[data-diggit-favorite]').forEach(button => {
      const active = has(button.dataset.productId);
      button.hidden = false;
      button.setAttribute('aria-pressed', String(active));
      const label = button.querySelector('[data-favorite-label]');
      if (label) label.textContent = active ? 'お気に入り登録済み' : 'お気に入りに追加';
    });
    renderDrawer();
  }
  function notify() {
    refresh();
    window.dispatchEvent(new CustomEvent('diggit:favorites-changed', {detail:{items:getAll(),persistent}}));
  }
  function toggle(product) {
    const clean = normalize([product])[0];
    if (!clean) return false;
    if (persistent) read();
    items = has(clean.id) ? items.filter(x => x.id !== clean.id) : items.concat(clean);
    try { localStorage.setItem(KEY, JSON.stringify(items)); persistent = true; }
    catch (_) { persistent = false; }
    notify();
    return has(clean.id);
  }
  window.DiggitFavorites = Object.freeze({getAll,has,toggle,refresh,
    isPersistent:() => persistent,
    subscribe(fn) { const listener = e => fn(e.detail); window.addEventListener('diggit:favorites-changed',listener); return () => window.removeEventListener('diggit:favorites-changed',listener); }
  });
  let drawer, trigger, panel, list, status;
  function renderDrawer() {
    if (!drawer) return;
    drawer.querySelector('[data-favorites-count]').textContent = String(items.length);
    const link = drawer.querySelector('[data-favorites-catalog]');
    link.hidden = !items.length;
    status.textContent = !persistent ? 'ブラウザに保存できないため、このページを閉じるとお気に入りは消えます。' : 'このブラウザに保存されます。ログインしても別の端末には同期されません。ブラウザデータを削除すると消えます。';
    list.replaceChildren();
    if (!items.length) {const p=document.createElement('li');p.textContent='まだお気に入りがありません。商品にある「お気に入りに追加」を押してください。';list.append(p);}
    items.forEach(item => {
      const li = document.createElement('li'), a = document.createElement('a'), remove = document.createElement('button');
      a.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'products/' + encodeURIComponent(item.handle);
      a.textContent = item.handle;
      remove.type='button'; remove.textContent='削除';remove.setAttribute('aria-label', item.handle + 'をお気に入りから削除');
      remove.addEventListener('click', event => {event.stopPropagation(); toggle(item); panel.querySelector('[data-favorites-close]').focus();});
      li.append(a,remove);list.append(li);
    });
  }
  function openDrawer(open) {
    panel.hidden = !open;trigger.setAttribute('aria-expanded',String(open));
    if(open) panel.querySelector('[data-favorites-close]').focus(); else trigger.focus();
  }
  function init() {
    drawer=document.querySelector('[data-favorites-drawer]');
    if(drawer) {
      trigger=drawer.querySelector('[data-favorites-trigger]');panel=drawer.querySelector('[data-favorites-panel]');list=drawer.querySelector('[data-favorites-list]');status=drawer.querySelector('[data-favorites-status]');drawer.hidden=false;
      trigger.addEventListener('click',()=>openDrawer(panel.hidden));
      drawer.querySelector('[data-favorites-close]').addEventListener('click',()=>openDrawer(false));
      document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!panel.hidden){openDrawer(false);}});
      document.addEventListener('click',e=>{if(!panel.hidden&&!drawer.contains(e.target)){panel.hidden=true;trigger.setAttribute('aria-expanded','false');}});
    }
    refresh();
    window.dispatchEvent(new CustomEvent('diggit:favorites-ready', {detail:{items:getAll(),persistent}}));
    new MutationObserver(records => {if(records.some(r=>Array.from(r.addedNodes).some(n=>n.nodeType===1&&(n.matches('[data-diggit-favorite]')||n.querySelector('[data-diggit-favorite]')))))refresh();}).observe(document.body,{childList:true,subtree:true});
  }
  document.addEventListener('click',e=>{
    const button=e.target.closest('[data-diggit-favorite]');if(!button)return;
    e.preventDefault();e.stopPropagation();toggle({id:button.dataset.productId,handle:button.dataset.productHandle});
    const feedback=document.querySelector('[data-favorites-feedback]');if(feedback)feedback.textContent=persistent?(has(button.dataset.productId)?'お気に入りに追加しました。':'お気に入りから削除しました。'):'このページ内のみ保存しました。ブラウザに保存できないため、ページを閉じると消えます。';
  });
  window.addEventListener('storage',e=>{if(e.key===KEY||e.key===null){read();notify();}});
  window.addEventListener('pageshow',()=>{if(persistent){read();refresh();}});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
